import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const joinGroup = async (resourceId = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceId) {
        console.log("no resourceId");
        return null;
    }
    console.log("CALLING SERVER with joinvotingpermissiongroup")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'joinvotingpermissiongroup',
            'apiToken': apiToken,
            'aboutformstateid': resourceId
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from joinvotingpermissiongroup call");
    }).catch((error) => { console.log(error); });
};

export default joinGroup;